import React, { useState } from 'react';
import './LanguagePopup.css';

const allLanguages = [
    { img: "/assets/us-flag.png", name: "English", code: "en" },
    { img: "/assets/indian-flag.png", name: "Hindi", code: "hi" },
];

/** 
 * Remove any existing googtrans cookies (current host + root domain)
 */
const destroyCookies = () => {
    const hostname = window.location.hostname;

    // remove cookie for current path
    document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    // remove for root domain if applicable
    if (hostname && hostname.includes(".")) {
        document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${hostname};`;
    }
};

/**
 * Ensure google translate widget exists
 */
const ensureGoogleTranslateWidget = () => {
    // If widget not loaded or removed, re-insert it
    if (!document.querySelector('#google_translate_element')) {
        const container = document.createElement('div');
        container.id = 'google_translate_element';
        container.style.display = 'none';
        document.body.appendChild(container);
    }

    // If the global init function exists, call it again
    if (window.google && window.google.translate && window.google.translate.TranslateElement) {
        new window.google.translate.TranslateElement(
            {
                pageLanguage: 'en',
                autoDisplay: false
            },
            'google_translate_element'
        );
    }
};

/**
 * Retry-based Google Translate trigger function
 */
const triggerLanguageChange = (langCode) => {
    // Always destroy cookies first for a fresh state
    destroyCookies();

    // Make sure translate widget is active
    ensureGoogleTranslateWidget();

    if (langCode === 'en') {
        // Reset to English: remove Google banner, clear translated classes
        const frame = document.querySelector("iframe.goog-te-banner-frame");
        document.body.classList.remove("translated-ltr");
        document.body.classList.remove("translated-rtl");
        if (frame) frame.remove();
        // Refresh the page so it reverts to original English
        window.location.reload();
        return;
    }

    // Apply translation using the hidden dropdown
    const tryChange = () => {
        const select = document.querySelector("select.goog-te-combo");
        if (select) {
            // Ensure all elements marked as notranslate remain unaffected
            document.querySelectorAll('.notranslate').forEach(el => {
                el.classList.add('notranslate');
                el.setAttribute('translate', 'no');
            });
            select.value = langCode;
            select.dispatchEvent(new Event("change"));
        } else {
            setTimeout(tryChange, 300); // retry until dropdown is available
        }
    };
    tryChange();
};

const LanguagePopup = ({ onClose }) => {
    const [search, setSearch] = useState("");

    const filteredLanguages = allLanguages.filter(lang =>
        lang.name.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div
            className="navbar-section-language-overlay notranslate"
            translate="no"
            onClick={onClose}
        >
            <div
                className="navbar-section-language-popup"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="navbar-section-language-list">
                    <ul>
                        {filteredLanguages.map((lang, index) => (
                            <li
                                key={index}
                                onClick={() => {
                                    triggerLanguageChange(lang.code);
                                    onClose();
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px"
                                    }}
                                >
                                    <img
                                        src={lang.img}
                                        alt={lang.name}
                                        style={{ width: "20px", height: "20px" }}
                                    />
                                    {lang.name}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default LanguagePopup;
